import { Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { PdfReferencesListItem } from "./pdf-references-list-item"

export function PdfReferencesList({ items, emptyLabel }) {
    if (!items?.length) {
        return <Typography sx={{ fontSize: "10px", color: "#7b8794" }}>{emptyLabel}</Typography>
    }

    return <Repeat list={items} item={<PdfReferencesListItem />} />
}
